import {
    RESET_GAME_ACTION,
    ADD_WORD_ACTION,
    REMOVE_WORD_ACTION,
    ENTER_COLLECTING_MODE_ACTION,
    ENTER_IDLE_MODE_ACTION,
    COLLECT_LETTER_ACTION,
    MARK_LETTERS_AS_USED_ACTION,
} from '../constants';

const collectedLettersReducer = (state = [], action) => {
    switch (action.type) {
        case COLLECT_LETTER_ACTION:
            return [...state, action.letter];
        case RESET_GAME_ACTION:
        case ADD_WORD_ACTION:
        case REMOVE_WORD_ACTION:
        case ENTER_IDLE_MODE_ACTION:
        case ENTER_COLLECTING_MODE_ACTION:
            return [];
        case MARK_LETTERS_AS_USED_ACTION:
            return state.map(letter => {
                if (action.letterIds.includes(letter.id)) {
                    letter = {...letter, used: true};
                }
                return letter;
            });
        default:
            return state;
    }
};
export default collectedLettersReducer;
